import React, { useState } from 'react';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });
  const [messageSent, setMessageSent] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' }); // Clear error message when input changes
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form fields
    const errors = {};
    if (!formData.name.trim()) {
      errors.name = 'Name is required';
    }
    if (!formData.phone.trim()) {
      errors.phone = 'Phone number is required';
    } else if (!/^\d{10}$/.test(formData.phone)) {
      errors.phone = 'Phone number should be exactly 10 digits';
    }
    if (!formData.email.trim()) {
      errors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = 'Invalid email format';
    }
    if (!formData.message.trim()) {
      errors.message = 'Message is required';
    }

    // If there are errors, don't submit the form
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    try {
      const response = await fetch('https://server-admin-naub.onrender.com/SetData', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        console.log('Message sent successfully!');
        setMessageSent(true);
        // Reset form after successful submission
        setFormData({
          name: '',
          phone: '',
          email: '',
          message: ''
        });
      } else {
        console.error('Failed to send message');
      }
    } catch (error) {
      console.error('Error sending message:', error);
    }
  };

  return (
    <div className=''>
      {messageSent ? (
        <div className="text-center text-2xl justify-center h-full flex w-full text-[#005A9A] font-bold mt-6">
          Your message has been sent!
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="flex flex-col space-y-4">
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            className={`w-full p-3 border border-gray-300 rounded focus:outline-none focus:border-blue-500 ${errors.name && 'border-red-500'}`}
          />
          {errors.name && <div className="text-red-500 text-sm">{errors.name}</div>}
          <input
            type="text"
            name="phone"
            placeholder="Your Phone Number"
            value={formData.phone}
            onChange={handleChange}
            className={`w-full p-3 border border-gray-300 rounded focus:outline-none focus:border-blue-500 ${errors.phone && 'border-red-500'}`}
          />
          {errors.phone && <div className="text-red-500 text-sm">{errors.phone}</div>}
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            className={`w-full p-3 border border-gray-300 rounded focus:outline-none focus:border-blue-500 ${errors.email && 'border-red-500'}`}
          />
          {errors.email && <div className="text-red-500 text-sm">{errors.email}</div>}
          <textarea
            name="message"
            rows="5"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
            className={`w-full p-3 border border-gray-300 rounded focus:outline-none focus:border-blue-500 ${errors.message && 'border-red-500'}`}
          />
          {errors.message && <div className="text-red-500 text-sm">{errors.message}</div>}
          <button
            type="submit"
            className="w-full bg-[#005A9A] text-white py-2 uppercase rounded hover:bg-[#012A47] focus:outline-none focus:bg-blue-600"
          >
            Send Message
          </button>
        </form>
      )}
    </div>
  );
};

export default ContactForm;
